// SET_MESSAGE

export const setMessage = (data) => ({
  type: 'SET_MESSAGE',
  data: data
});


// WEBPACK FOOTER //
// ./src/actions/messageManagment.js